import React from 'react'

export default function Cookies() {
  return (
      <div className='mb-10 px-3 md:px-10'>
          <p className='text-2xl font-bold text-red-700 my-10 text-center'> Cookie Policy for Quorum of Collaborative Learning(QOC) </p>

          Last updated: 03/04/2024 <br /> <br />

          This Cookie Policy explains what cookies are, how QOC uses them on its website, and what
          users can do to manage their cookie preferences.
          <p  className='text-xl font-bold text-red-700 my-7'> 1. What are Cookies: </p>
          Cookies are small text files placed on a user's device (computer, tablet, smartphone) when they
          visit a website. They are commonly used to make websites work efficiently and provide
          information to the website owners.

          <p  className='text-xl font-bold text-red-700 my-7'> 2. How QOC Uses Cookies: </p>
          QOC uses cookies for various purposes, including: <br /> <br />
          <strong>- Essential Cookies:</strong> These cookies are necessary for the website to function properly. They
          enable basic functionalities like page navigation and access to secure areas of the website. <br />
          <strong>- Analytical Cookies:</strong> QOC uses these cookies to analyze how users interact with the
          website. Information collected is used to improve website performance and user experience. <br />
          <strong>- Functional Cookies:</strong> These cookies allow QOC to remember choices users make (such as
          language preferences) and provide enhanced, personalized features. <br />
          <strong>- Third-Party Cookies:</strong> QOC may also use third-party cookies to analyze website traffic and
          user behavior. These cookies are governed by the respective privacy policies of the third
          parties. <br />
          <p  className='text-xl font-bold text-red-700 my-7'> 3. Types of Cookies QOC Uses: </p> 
          <strong>- Session Cookies:</strong> These are temporary cookies that are erased when users close their
          browsers. They are used to store session information. <br />
          <strong>- Persistent Cookies:</strong> These cookies remain on a user's device for a set period, facilitating
          the recognition of the user during subsequent visits. <br />
          <p  className='text-xl font-bold text-red-700 my-7'> 4. Managing Cookies: </p>
          Users have the option to manage cookie preferences directly from their browsers. Most
          browsers allow users to accept or reject all cookies or accept only certain types of cookies. <br /> <br />
          <strong>- Browser Settings:</strong> Users can adjust their browser settings to manage cookies. Information
          about cookie management is available in the browser's help section. <br />
          <strong>- Third-Party Tools:</strong> Users can opt-out of third-party cookies using online tools provided by
          certain third-party analytics services. <br />
          <p  className='text-xl font-bold text-red-700 my-7'> 5. Changes to the Cookie Policy: </p>
          QOC may update this Cookie Policy to reflect changes in technology or legal requirements.
          Users are encouraged to check this page periodically for any updates.
          <p  className='text-xl font-bold text-red-700 my-7'> 6. Contact Information: </p>
          For any questions about QOC use of cookies or this Cookie Policy, users can contact QOC at <a className='font-bold inline underline' href='mailto:qoclearning@gmail.com'>qoclearning@gmail.com</a>.
          By continuing to use QOC's website, users consent to the use of cookies as outlined in this
          Cookie Policy.
      </div>
  )
}
